import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ButtonEditor } from "../PrimaryButtonBlock/Editor";
import { SecondaryButton } from "./SecondaryButton";
import { defaultData } from "./SecondaryButtonBlockDefaultData";
import { meta } from "./SecondaryButtonBlockMetaData";

export const SecondaryButtonBlock: BlockExport = {
  type: "component",
  Block: SecondaryButton,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-button",
    size: 24,
  },
  defaultData,
  Editor: ButtonEditor,
  meta,
};
